import React from 'react';

import PipelinesCell from './PipelinesCell';
import RowsActions from './RowsActions';

const COLUMN_IDS = {
  LABEL: 'label',
  PIPELINES: 'pipelines',
  ACTIONS: 'actions',
};

const pipelineTagsTableColumns = [
  {
    id: COLUMN_IDS.LABEL,
    name: 'Label',
    selector: row => row.label,
    sortable: true,
    sortField: COLUMN_IDS.LABEL,
  },
  {
    id: COLUMN_IDS.PIPELINES,
    name: 'Pipelines',
    cell: row => <PipelinesCell row={row} />,
  },
  {
    id: COLUMN_IDS.ACTIONS,
    name: 'Actions',
    button: true,
    cell: row => <RowsActions row={row} />,
  },
];

export default pipelineTagsTableColumns;
